import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import posthog, { isAnalyticsEnabled } from "./posthog";

export default function PageviewTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!isAnalyticsEnabled()) return;
    posthog.capture("$pageview", { $current_url: window.location.href });
    const leaveUrl = window.location.href;
    return () => {
      posthog.capture("$pageleave", { $current_url: leaveUrl });
    };
  }, [location.pathname, location.search]);

  return null;
}
